import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import DashboardIcon from '@material-ui/icons/Dashboard';
import Persons from '@material-ui/icons/SupervisorAccount';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';
import CRMInput from '../LinkedTables/LinkedTables';
import PlaylistAdd from '@material-ui/icons/PlaylistAdd';
import Loader from '../../shared/Loader/Loader';
import { Avatar, Box, Tooltip, CardMedia, Button, TextField } from '@material-ui/core';
import Auth from '../../utils/authenticate';
import { withRouter } from 'react-router-dom';
import { PersonAdd } from '@material-ui/icons';
import SecurityIcon from '@material-ui/icons/Security';
import UserAccess from '../UserAccess/UserAccess';
import Service from "../../config/networkutils";
import { withSnackbar } from 'notistack';
import ManageHR from '../UserAccess/ManageHR';
import Popover from '@material-ui/core/Popover';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';
import RoleTabs from '../Roles/RoleTabs';
import { BlockLoading } from 'react-loadingg';
import UIRefereshment from '../UIRefereshment/UIRefereshment';
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';
import SubContractorComponent from '../SubContractor/SubContractorComponent';
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation';
import LeaveAdminAccess from '../Leaves/LeaveAdminAccess';
import { Autocomplete } from '@material-ui/lab';
import BankHolidayTable from '../BankHoliday/BankHolidayTable';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import UsersTab from '../Users/UsersTab';
import TocIcon from '@material-ui/icons/Toc';
import AssessmentIcon from '@material-ui/icons/Assessment';

// import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import { getCookie } from '../../utils/CookieHelper';
import AtrHome from '../ATR/AtrHome';
import ResourceProfile from '../ResourceProfile/ResourceProfile';
import TableChartIcon from '@material-ui/icons/TableChart';
import OtherInputs from '../OtherInputs/OtherInputs';
import { getPrimaryColor } from '../Helper/CommonThings';

const drawerWidth = 190;

const useStyles = (theme) => ({
    root: {
        display: 'flex',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),

    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing(7) + 1,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9) + 1,
        },
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 1),
        ...theme.mixins.toolbar,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(2),
        width: `calc(100% - ${drawerWidth}px)`,
    },
    profileButton: {
        marginLeft: "auto",
        cursor: "pointer"
    },
    primaryColorBg: {
        color: getPrimaryColor()
    },
    orange: {
        color: getPrimaryColor(),
        backgroundColor: '#fff',
        width: theme.spacing(4),
        height: theme.spacing(4),
    },
    userAvatar: {
        height: '50px',
        width: '50px',
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: '10px'
    },
    infoBox: {
        marginBottom: '15px'
    },
    profileContainer: {
        textAlign: 'center'
    },
    businessUnitAutocomplete: {
        '& .MuiInputBase-input': {
            color: '#fff'
        },
        '& .MuiInputLabel-root': {
            color: '#fff'
        },
        '& .MuiInputLabel-root.Mui-focused': {
            color: '#fff'
        },
        '& .MuiAutocomplete-popupIndicator': {
            color: '#fff'
        },
        '& .MuiAutocomplete-clearIndicator': {
            color: '#fff'
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#fff'
            },
            '&:hover fieldset': {
                borderColor: '#fff'
            },
            '&.Mui-focused fieldset': {
                borderColor: '#fff'
            }
        }
    }
});
var pjson = require('../../../package.json');

class TabHost extends React.PureComponent {
    render() {
        const { activeComp, visited, name, renderContent } = this.props
        const isVisible = activeComp === name

        if (!isVisible && !visited) {
            return null
        }

        return <div style={{ display: isVisible ? 'block' : 'none' }}>{renderContent()}</div>
    }
}

class Home extends React.Component {

    constructor() {
        super()
        this.state = {
            sideMenu: [
                // 'CRM', 'CRM Inputs', "Roles", "Employees", "Unsecured", "Secured", "Reports", "Users & Access"
            ],
            menu_open: false,
            current_comp: '',
            isLoading: false,
            anchorEl: null,
            userAccess: {},
            userData: { first_name: '', last_name: '' },
            isInitLoading: true,
            selectedBU: null,
            manageUser: {},
            buData: {},
            visitedComponents: {}
        }

    }

    componentDidMount() {
        this.fetchUserAccess()
        this.setState({ userData: Auth.user() })
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.current_comp !== this.state.current_comp && this.state.current_comp) {
            if (!this.state.visitedComponents[this.state.current_comp]) {
                this.setState((state) => ({
                    visitedComponents: {
                        ...state.visitedComponents,
                        [state.current_comp]: true
                    }
                }))
            }
        }
    }

    getBUData() {
        const token = Auth.token()
        const user = Auth.user()

        Service.get(`/api/users/get_admin_user_data/`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                const defaultBusinessUnitId = res.data?.default_business_unit?.id
                const defaultBU = res.data?.business_units?.find((bu) => bu.id === defaultBusinessUnitId || bu.business_unit === defaultBusinessUnitId)
                console.log(defaultBU)
                this.setState({
                    buData: res.data,
                    selectedBU: defaultBU || null
                }, () => {
                    this.compileMenu(user)
                })

            })
            .catch(error => {
                // this.setState({ isLoading: false })
                this.props.enqueueSnackbar('Uh oh! Something went wrong. Please try reloading the page or try later.', {
                    variant: 'error',
                    persist: true
                });
            });
    }

    fetchUserAccess() {
        const user = Auth.user()
        const token = Auth.token()

        Service.get(`/api/access/?uid=` + user.id, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                localStorage.setItem('ptd_ts_access', JSON.stringify(res.data.length ? res.data[0] : {}))
                this.setState({
                    userAccess: res.data.length ? res.data[0] : {}
                }, () => {
                    this.getBUData()

                });

            })
            .catch(error => {
                this.props.enqueueSnackbar('Uh oh! Something went wrong. Please try reloading the page or try later.', {
                    variant: 'error',
                    persist: true
                });
            });
    }

    compileMenu(user) {
        const access = { ...this.state.userAccess.access }
        let menus = []
        var defaultView = '';
        var hashDone = false;
        let viewHash;
        // if (sessionStorage.getItem("lasturi") === null) {
        viewHash = window.location.hash.replace('#', '').replace('%20', ' ').replace('%20', ' ');
        if (access.l0a && access.l0a.l0a_a) {
            if (viewHash === 'Dashboard') {
                hashDone = true;
                this.setState({
                    current_comp: viewHash,
                })
            }
            menus.push('Dashboard')
            if (defaultView === '') {
                defaultView = 'Dashboard'
            }
            // if (access.l1a && access.l1a.l1a_a) {
            //     menus.push('CRM')
            // }
            if (access.l2a && access.l2a.l2a_a) {
                if (viewHash === 'CRM Inputs') {
                    hashDone = true;
                    this.setState({
                        current_comp: viewHash,
                    })
                }
                menus.push('CRM Inputs')
                if (defaultView === '') {
                    defaultView = 'CRM Inputs'
                }

                if (viewHash === 'Other Inputs') {
                    hashDone = true;
                    this.setState({
                        current_comp: viewHash,
                    })
                }
                menus.push('Other Inputs')
                if (defaultView === '') {
                    defaultView = 'Other Inputs'
                }
            }
            if (access.l3a && access.l3a.l3a_a) {
                if (viewHash === 'Roles') {
                    hashDone = true;
                    this.setState({
                        current_comp: viewHash,
                    })
                }
                menus.push('Roles')
                if (defaultView === '') {
                    defaultView = 'Roles'
                }
            }
            if (access.l4a && access.l4a.l4a_a) {
                if (viewHash === 'Employees') {
                    hashDone = true;
                    this.setState({
                        current_comp: viewHash,
                    })
                }
                menus.push('Employees')
                if (defaultView === '') {
                    defaultView = 'Employees'
                }
            }

            if (access.l12a && access.l12a.l12a_a) {
                if (viewHash === 'SubContractor') {
                    hashDone = true;
                    this.setState({
                        current_comp: viewHash,
                    })
                }
                menus.push('SubContractor')
            }

            if (viewHash === 'ATR') {
                hashDone = true;
                this.setState({
                    current_comp: viewHash,
                })
            }
            menus.push('ATR')
            if (defaultView === '') {
                defaultView = 'ATR'
            }


            if(viewHash === 'Resource Profile') {
                hashDone = true;
                this.setState({
                    current_comp: viewHash,
                })
            }
            menus.push('Resource Profile')
            if (defaultView === '') {
                defaultView = 'Resource Profile'
            }   

            // if (access.l11a && access.l11a.l11a_a) {
            //     if (viewHash === 'Admin Level Approval') {
            //         hashDone = true;
            //         this.setState({
            //             current_comp: viewHash,
            //         })
            //     }
            //     menus.push('Admin Level Approval')
            //     if (defaultView === '') {
            //         defaultView = 'Admin Level Approval'
            //     }
            // }

            // if (access.l11a && access.l11a.l11a_b) {
            //     if (viewHash === 'User Level Approval') {
            //         hashDone = true;
            //         this.setState({
            //             current_comp: viewHash,
            //         })
            //     }
            //     menus.push('User Level Approval')
            //     if (defaultView === '') {
            //         defaultView = 'User Level Approval'
            //     }
            // }

            // if (access.l5a && access.l5a.l5a_a) {
            //     menus.push('Unsecured')
            // }
            // if (access.l6a && access.l6a.l6a_a) {
            //     menus.push('Secured')
            // }
            // if (access.l7a && access.l7a.l7a_a) {
            //     menus.push('Reports')
            // }
            // if (access.l9a && access.l9a.l9a_a) {
            //     menus.push('Combined Resources')
            // }
            // 
            // if (access.l7a && access.l7a.l7a_a) {
            //     menus.push('Reports')
            //     if (defaultView === '') {
            //         defaultView = 'Reports'
            //     }
            // }

            if (this.state.buData.manage_user) {
                if (viewHash === 'Manage Users') {
                    hashDone = true;
                    this.setState({
                        current_comp: viewHash,
                    })
                }
                menus.push('Manage Users')
                if (defaultView === '') {
                    defaultView = 'Manage Users'
                }
            }

            if (user.is_admin === true) {
                if (viewHash === 'Business Unit Admin') {
                    hashDone = true;
                    this.setState({
                        current_comp: viewHash,
                    })
                }
                menus.push('Business Unit Admin')
                if (defaultView === '') {
                    defaultView = 'Business Unit Admin'
                }
            }

            if (access.l11a && access.l11a.l11a_a) {
                if (viewHash === 'Leaves Admin') {
                    hashDone = true;
                    this.setState({
                        current_comp: viewHash,
                    })
                }
                menus.push('Leaves Admin')
                if (defaultView === '') {
                    defaultView = 'Leaves Admin'
                }
            }

            if (viewHash === 'Bank Holiday') {
                hashDone = true;
                this.setState({
                    current_comp: viewHash,
                })
            }
            menus.push('Bank Holiday')
            if (defaultView === '') {
                defaultView = 'Bank Holiday'
            }



            // if (viewHash === 'UIRefreshment') {

            // // if (viewHash === 'Reports') {
            //     hashDone = true;
            //     this.setState({
            //         current_comp: viewHash,
            //     })
            // }
            // menus.push('UIRefreshment')
            // if (defaultView === '') {
            //     defaultView = 'UIRefreshment'
            // }



            // if (viewHash === 'Graph Component') {
            //     hashDone = true;
            //     this.setState({
            //         current_comp: viewHash,
            //     })
            // }
            // menus.push('Graph Component')
            // if (defaultView === '') {
            //     defaultView = 'Graph Component'
            // }
        }
        if (hashDone) {
            this.setState({
                sideMenu: menus,
                isInitLoading: false
            })
        } else {
            this.setState({
                sideMenu: menus,
                current_comp: "Dashboard",
                isInitLoading: false
            })
        }
        // } else if (sessionStorage.getItem("lasturi").includes('?')) {
        //     if (access.l0a && access.l0a.l0a_a) {

        //         menus.push('Dashboard');

        //         if (access.l2a && access.l2a.l2a_a) {

        //             menus.push('CRM Inputs');

        //         }
        //         if (access.l3a && access.l3a.l3a_a) {

        //             menus.push('Roles');

        //         }
        //         if (access.l4a && access.l4a.l4a_a) {

        //             menus.push('Employees');

        //         }
        //         // if (access.l5a && access.l5a.l5a_a) {
        //         //     menus.push('Unsecured')
        //         // }
        //         // if (access.l6a && access.l6a.l6a_a) {
        //         //     menus.push('Secured')
        //         // }
        //         // if (access.l7a && access.l7a.l7a_a) {
        //         //     menus.push('Reports')
        //         // }
        //         // if (access.l9a && access.l9a.l9a_a) {
        //         //     menus.push('Combined Resources')
        //         // }
        //         if (user.is_hr === true) {

        //             menus.push('Manage Users');

        //         }
        //         if (user.is_admin === true) {

        //             menus.push('Manage HR');

        //         }
        //     }
        //     this.setState({
        //         sideMenu: menus,
        //         isInitLoading: false,
        //         current_comp: "Dashboard",
        //     }, () => {
        //         window.history.pushState({ id: window.location.href }, '', sessionStorage.getItem('lasturi'))
        //     })

        // } else {
        //     viewHash = window.location.hash.replace('#', '').replace('%20', ' ').replace('%20', ' ');
        //     if (access.l0a && access.l0a.l0a_a) {
        //         if (viewHash === 'Dashboard') {
        //             hashDone = true;
        //             this.setState({
        //                 current_comp: viewHash,
        //             })
        //         }
        //         menus.push('Dashboard')
        //         if (defaultView === '') {
        //             defaultView = 'Dashboard'
        //         }
        //         // if (access.l1a && access.l1a.l1a_a) {
        //         //     menus.push('CRM')
        //         // }
        //         if (access.l2a && access.l2a.l2a_a) {
        //             if (viewHash === 'CRM Inputs') {
        //                 hashDone = true;
        //                 this.setState({
        //                     current_comp: viewHash,
        //                 })
        //             }
        //             menus.push('CRM Inputs')
        //             if (defaultView === '') {
        //                 defaultView = 'CRM Inputs'
        //             }
        //         }
        //         if (access.l3a && access.l3a.l3a_a) {
        //             if (viewHash === 'Roles') {
        //                 hashDone = true;
        //                 this.setState({
        //                     current_comp: viewHash,
        //                 })
        //             }
        //             menus.push('Roles')
        //             if (defaultView === '') {
        //                 defaultView = 'Roles'
        //             }
        //         }
        //         if (access.l4a && access.l4a.l4a_a) {
        //             if (viewHash === 'Employees') {
        //                 hashDone = true;
        //                 this.setState({
        //                     current_comp: viewHash,
        //                 })
        //             }
        //             menus.push('Employees')
        //             if (defaultView === '') {
        //                 defaultView = 'Employees'
        //             }
        //         }
        //         // if (access.l5a && access.l5a.l5a_a) {
        //         //     menus.push('Unsecured')
        //         // }
        //         // if (access.l6a && access.l6a.l6a_a) {
        //         //     menus.push('Secured')
        //         // }
        //         // if (access.l7a && access.l7a.l7a_a) {
        //         if (viewHash === 'OtherTasks') {
        //             hashDone = true;
        //             this.setState({
        //                 current_comp: viewHash,
        //             })
        //         }
        //         menus.push('OtherTasks')
        //         if (defaultView === '') {
        //             defaultView = 'OtherTasks'
        //         }
        //         // }
        //         // if (access.l9a && access.l9a.l9a_a) {
        //         //     menus.push('Combined Resources')
        //         // }
        //         if (user.is_hr === true) {
        //             if (viewHash === 'Manage Users') {
        //                 hashDone = true;
        //                 this.setState({
        //                     current_comp: viewHash,
        //                 })
        //             }
        //             menus.push('Manage Users')
        //             if (defaultView === '') {
        //                 defaultView = 'Manage Users'
        //             }
        //         }
        //         if (user.is_admin === true) {
        //             if (viewHash === 'Manage HR') {
        //                 hashDone = true;
        //                 this.setState({
        //                     current_comp: viewHash,
        //                 })
        //             }
        //             menus.push('Manage HR')
        //             if (defaultView === '') {
        //                 defaultView = 'Manage HR'
        //             }
        //         }
        //     }
        //     if (hashDone) {
        //         this.setState({
        //             sideMenu: menus,
        //             isInitLoading: false
        //         })
        //     } else {
        //         this.setState({
        //             sideMenu: menus,
        //             current_comp: "Dashboard",
        //             isInitLoading: false
        //         })
        //     }
        // }
    }

    removeFromMenu(value) {
        let array = [...this.state.sideMenu];
        const index = array.indexOf(value);
        if (index > -1) {
            array.splice(index, 1);
        }
        this.setState({ sideMenu: array })
    }

    handleDrawerOpen = () => {
        this.setState({ menu_open: true })
    };

    handleDrawerClose = () => {
        this.setState({ menu_open: false })
    };

    changeComp = (compName) => {
        // sessionStorage.setItem('lasturi', `${window.location.protocol}//${window.location.host}/#${compName}`)
        window.location.hash = compName;
        let hash = window.location.hash
        window.history.pushState(null, '', window.location.pathname + hash);
        this.setState((prevState) => ({
            current_comp: compName,
            visitedComponents: {
                ...prevState.visitedComponents,
                [compName]: true
            }
        }))
    }

    setLoading = (flag) => {
        this.setState({ isLoading: flag })
    }

    renderDashboardTab = () => <UIRefereshment access={this.state.userAccess} />

    renderCRMInputsTab = () => <CRMInput isLoading={this.setLoading} access={this.state.userAccess} />

    renderOtherReportsTab = () => <OtherInputs access={this.state.userAccess} />

    renderRolesTab = () => <RoleTabs isLoading={this.setLoading} access={this.state.userAccess} />

    renderEmployeesTab = () => <UsersTab access={this.state.userAccess} />

    renderLeavesAdminTab = () => <LeaveAdminAccess isLoading={this.setLoading} access={this.state.userAccess} />

    renderManageUsersTab = () => <UserAccess buData={this.state.buData} isLoading={this.setLoading} access={this.state.userAccess} />

    renderBusinessUnitAdminTab = () => <ManageHR />

    renderSubContractorTab = () => <SubContractorComponent />

    renderBankHolidayTab = () => <BankHolidayTable isLoading={this.setLoading} access={this.state.userAccess} />

    handleAvatarClick = (event) => {
        this.setState({ anchorEl: event.currentTarget })
    }

    handleClose = () => {
        this.setState({ anchorEl: null })
    }

    // handleMenuClick = (e) => {
    //     if (e.target.id === 'profile') {
    //         this.setState({ viewClass: 'Profile', anchorEl: null });
    //     } else if (e.target.id === 'change_passsword') {
    //         this.setState({ viewClass: 'Change Password', anchorEl: null });
    //     } else if (e.target.id === 'signout') {
    //         Auth.removeToken(() => {
    //             this.props.history.push('/')
    //         })
    //     }
    // };
    handleMenuClick = () => {
        Auth.removeToken(() => {
            this.props.history.push('/')
        })
    }

    updateBusinessUnit = (value) => {
        // /api/user/business/unit/update_default_business_unit/
        this.setState({
            isInitLoading: true
        })
        const token = Auth.token()
        Service.patch(`/api/user/business/unit/update_default_business_unit/`, {
            headers: {
                Authorization: "Token " + token,
            },
            data: {
                user: this.state.userData?.id,
                bu_unit: value.id
            }
        })
            .then(res => {
                let user = JSON.parse(getCookie("ptd_ts_user"));
                user.default_business_unit = value.business_unit
                localStorage.setItem('ptd_ts_user', JSON.stringify(user))
                this.setState({
                    isInitLoading: false
                })
                this.props.enqueueSnackbar('Default Business Unit updated successfully!', {
                    variant: 'success',
                });

            })
            .catch(error => {
                // this.setState({ isLoading: false })
                this.props.enqueueSnackbar('Uh oh! Something went wrong. Please try reloading the page or try later.', {
                    variant: 'error',
                    persist: true
                });
            });
    }


    render() {
        const { classes } = this.props
        const activeComp = this.state.current_comp
        const visited = this.state.visitedComponents
        return (<>
            {this.state.isInitLoading ? <BlockLoading color={getPrimaryColor()} /> :
                <div className={classes.root} >
                    <CssBaseline />
                    <AppBar
                        position="fixed"
                        className={clsx(classes.appBar, {
                            [classes.appBarShift]: this.state.menu_open,
                        })}
                    >
                        <Toolbar >
                            <IconButton
                                color="inherit"
                                aria-label="open drawer"
                                onClick={this.handleDrawerOpen}
                                edge="start"
                                className={clsx(classes.menuButton, {
                                    [classes.hide]: this.state.menu_open,
                                })}
                            >
                                <MenuIcon />
                            </IconButton>
                            <Typography variant="h6" noWrap>
                                Resource Management System
                            </Typography>
                            <div className={classes.profileButton}>
                                <PopupState variant="popover" popupId="demo-popup-popover">
                                    {(popupState) => (
                                        <div>
                                            <Box display='flex' alignItems='center' justifyContent='center' style={{ marginRight: '10px', marginTop: '5px' }}>
                                                {this.state.buData?.business_units?.length > 1 ? (
                                                    <Autocomplete
                                                        className={classes.businessUnitAutocomplete}
                                                        getOptionLabel={(option) => (option && option.name ? String(option.name) : '')}
                                                        value={this.state.selectedBU}
                                                        onChange={(e, v) => {
                                                            if (v) {
                                                                this.setState({
                                                                    selectedBU: v
                                                                }, () => {
                                                                    this.updateBusinessUnit(v)
                                                                })
                                                            }
                                                        }}
                                                        options={this.state.buData?.business_units ? this.state.buData?.business_units : []}
                                                        renderInput={(params) => <TextField label='Business Unit' {...params} variant="outlined" size="small" style={{ width: '200px', marginRight: '10px' }} />}
                                                    />) : this.state.buData?.default_business_unit ?
                                                    <Box marginRight={1}>
                                                        {this.state.buData?.default_business_unit ? <Typography variant="h6" noWrap>{this.state.buData?.default_business_unit?.name}</Typography> : ''}
                                                    </Box> :
                                                    null}
                                                <Avatar style={{ marginRight: '5px' }} {...bindTrigger(popupState)} className={classes.orange}>
                                                    <Box fontSize={12}>
                                                        <Typography>
                                                            {(this.state.userData?.first_name ? this.state.userData?.first_name?.charAt(0) : '') + (this.state.userData?.last_name ? this.state.userData?.last_name?.charAt(0) : '')}
                                                        </Typography>
                                                    </Box>
                                                </Avatar>
                                                <Popover
                                                    {...bindPopover(popupState)}
                                                    anchorOrigin={{
                                                        vertical: 'bottom',
                                                        horizontal: 'center',
                                                    }}
                                                    transformOrigin={{
                                                        vertical: 'top',
                                                        horizontal: 'center',
                                                    }}
                                                >
                                                    <Box p={2} className={classes.profileContainer}>

                                                        <CardMedia
                                                            component="img"
                                                            alt="Balfour Beatty"
                                                            image={'user.png'}
                                                            title="Balfour Beatty"
                                                            className={classes.userAvatar}
                                                        />

                                                        <Box className={classes.infoBox}>
                                                            <Typography color="inherit" variant="h5">{this.state.userData?.first_name + ' ' + this.state.userData?.last_name}</Typography>
                                                            <Typography variant="h6">
                                                                <small>{this.state.userData?.email}</small>
                                                            </Typography>
                                                        </Box>

                                                        {/* <MenuItem id="signout" onClick={this.handleMenuClick}>Sign Out</MenuItem> */}
                                                        <Button variant="outlined" onClick={this.handleMenuClick}>Sign Out</Button>
                                                    </Box>
                                                </Popover>
                                            </Box>
                                        </div>
                                    )}
                                </PopupState>
                            </div>
                        </Toolbar>
                    </AppBar>
                    <Drawer
                        variant="permanent"
                        className={clsx(classes.drawer, {
                            [classes.drawerOpen]: this.state.menu_open,
                            [classes.drawerClose]: !this.state.menu_open,
                        })}
                        classes={{
                            paper: clsx({
                                [classes.drawerOpen]: this.state.menu_open,
                                [classes.drawerClose]: !this.state.menu_open,
                            }),
                        }}
                    >
                        <div className={classes.toolbar}>
                            <CardMedia
                                component="img"
                                alt="Balfour Beatty"
                                image={'bb.png'}
                                title="Balfour Beatty"
                                style={{ width: '130px' }}
                            />
                            <IconButton onClick={this.handleDrawerClose}>
                                <ChevronLeftIcon />
                            </IconButton>
                        </div>
                        <Divider />
                        <List className={classes.primaryColorBg}>
                            {this.state.sideMenu.map((text, index) => (
                                <Tooltip title={!this.state.menu_open ? text : ''} placement="bottom" key={text}>
                                    <ListItem
                                        button
                                        key={text}
                                        onClick={() => { this.changeComp(text) }}
                                        selected={this.state.current_comp === text}
                                    >
                                        <ListItemIcon className={classes.primaryColorBg}>
                                            {
                                                text === 'Dashboard' ? <DashboardIcon /> :
                                                    text === 'CRM Inputs' ? <PlaylistAdd /> :
                                                        text === 'Roles' ? <Persons /> :
                                                            text === 'Employees' ? <PersonAdd /> :
                                                                text === 'Leaves Admin' ? <InsertInvitationIcon /> :
                                                                    text === 'Manage Users' ? <SecurityIcon /> :
                                                                        text === 'Business Unit Admin' ? <GroupAddIcon /> :
                                                                            text === 'SubContractor' ? <SupervisedUserCircleIcon /> :
                                                                                text === 'Bank Holiday' ? <AccountBalanceIcon /> :
                                                                                text === 'ATR' ? <TocIcon /> :
                                                                                text === 'Resource Profile' ? <AssessmentIcon /> :
                                                                                        text === 'Other Inputs' ? <TableChartIcon /> :
                                                                                            null
                                            }
                                        </ListItemIcon>
                                        <ListItemText primary={text} />
                                    </ListItem>
                                </Tooltip>
                            ))}
                        </List>
                        <Divider />
                    </Drawer>
                    <div style={{
                        position: 'absolute',
                        top: '0px',
                        right: '5px',
                        padding: '0px',
                        marginTop: '68px'
                    }}>
                        <Box fontSize={10} fontWeight="fontWeightLight" >
                            {"v" + pjson.version}
                        </Box>
                    </div>
                    <main className={classes.content}>
                        <div className={classes.toolbar} />

                        <TabHost activeComp={activeComp} visited={visited['Dashboard']} name='Dashboard' renderContent={this.renderDashboardTab} />
                        <TabHost activeComp={activeComp} visited={visited['CRM Inputs']} name='CRM Inputs' renderContent={() => <CRMInput isLoading={this.setLoading} access={this.state.userAccess} isActive={activeComp === 'CRM Inputs'} />} />
                        <TabHost activeComp={activeComp} visited={visited['Roles']} name='Roles' renderContent={this.renderRolesTab} />
                        <TabHost activeComp={activeComp} visited={visited['Employees']} name='Employees' renderContent={this.renderEmployeesTab} />
                        <TabHost activeComp={activeComp} visited={visited['Leaves Admin']} name='Leaves Admin' renderContent={this.renderLeavesAdminTab} />
                        <TabHost activeComp={activeComp} visited={visited['Manage Users']} name='Manage Users' renderContent={this.renderManageUsersTab} />
                        <TabHost activeComp={activeComp} visited={visited['Business Unit Admin']} name='Business Unit Admin' renderContent={this.renderBusinessUnitAdminTab} />
                        <TabHost activeComp={activeComp} visited={visited['SubContractor']} name='SubContractor' renderContent={this.renderSubContractorTab} />
                        <TabHost activeComp={activeComp} visited={visited['Bank Holiday']} name='Bank Holiday' renderContent={this.renderBankHolidayTab} />
                        <TabHost activeComp={activeComp} visited={visited['ATR']} name='ATR' renderContent={() => <AtrHome isLoading={this.setLoading} access={this.state.userAccess} isActive={activeComp === 'ATR'} />} />
                        <TabHost activeComp={activeComp} visited={visited['Resource Profile']} name='Resource Profile' renderContent={() => <ResourceProfile isLoading={this.setLoading} access={this.state.userAccess} isActive={activeComp === 'Resource Profile'} />} />
                        <TabHost activeComp={activeComp} visited={visited['Other Inputs']} name='Other Inputs' renderContent={this.renderOtherReportsTab} />
                        {/* {this.state.current_comp === 'Unsecured' ? <UnsecuredProjects isLoading={this.setLoading} access={this.state.userAccess} /> : null}
                        {/* {this.state.current_comp === 'UIRefreshment' ? <UIRefereshment access={this.state.userAccess} /> : null} */}
                        {/* {this.state.current_comp === 'Combined Resources' ? <PRPLiveChange isLoading={this.setLoading} access={this.state.userAccess} /> : null} */}
                    </main>
                    {this.state.isLoading ? <Loader /> : null}
                </div >
            }

        </>)
    }
}

export default withSnackbar(withRouter(withStyles(useStyles)(Home)))